import { AcceptedProps } from '../../../interface/accepted-props';

export const isWithShortcut = (props: AcceptedProps, hasAccessShorctut: boolean): boolean => {
  return props.inputConfig.config.showCreateBpOrDt === true
    && hasAccessShorctut
    && props.createDataForReference !== undefined
};